import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'
import React from 'react'

type Anchor = 'top' | 'left' | 'bottom' | 'right'

interface Props {
  title: string
  subTitle?: string
  handle: React.ReactElement
  anchor?: 'left' | 'top' | 'right' | 'bottom'
  position?: string
  float?: string
  top?: string
  IconBGColor?: string
  node?: React.ReactElement
  IconBoxShadow?: string
}

//entity is used to call and to store in profile, if it contains
export default function BasicDrawer(props: Props) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent | any) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return
      }

      setState({...state, [anchor]: open})
    }
  return (
    <Box sx={{backgroundColor: 'inherit'}}>
      <Box
        sx={{
          position: props.position ? props.position : 'fixed',
          top: props.top ? props.top : '70px',
          right: 0,
          fontSize: '10px',
          float: props.float ? props.float : '',
          borderBottomLeftRadius: '25px',
          borderTopLeftRadius: '25px',
          backgroundColor: props.IconBGColor ? props.IconBGColor : 'white',
          padding: 1,
          cursor: 'pointer',
          boxShadow: props.IconBoxShadow ? props.IconBoxShadow : 'none',
        }}
        onClick={toggleDrawer(props.anchor ?? 'right', true)}
      >
        {props.handle}
      </Box>
      <React.Fragment key={props.anchor ?? 'right'}>
        <Drawer
          anchor={props.anchor ?? 'right'}
          open={state[props.anchor ?? 'right']}
          onClose={toggleDrawer(props.anchor ?? 'right', false)}
          PaperProps={{
            sx: {
              width: '60em',
            },
          }}
        >
          <Box display={'flex'} justifyContent={'flex-start'} p={1}>
            <Button
              variant={'contained'}
              color={'inherit'}
              onClick={toggleDrawer(props.anchor ?? 'right', false)}
            >
              {' '}
              <CloseIcon />
            </Button>
          </Box>
          {props.node}
        </Drawer>
      </React.Fragment>
    </Box>
  )
}
